import * as React from 'react';
export const unknownSvg = React.forwardRef(function unknownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Zm1-10a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4Z',
      }),
    ),
  );
});
unknownSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var unknown = {
  category: 'flag',
  colorable: false,
  name: 'unknown',
  svg: unknownSvg,
};
